import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { ReactComponent as TimerIcon } from "src/assets/icons/timer.svg";
import { blogCardTrns } from "./trns";

interface Props {
  className?: string;
  read_time: string;
}

export const ReadingTime: FC<Props> = ({ className, read_time }) => {
  const { t } = useTranslation();

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <TimerIcon />
      <span className="text-purple-base text-sm text-center md:text-lg">
        {`${t(blogCardTrns.readingTime)} ${read_time}`}
      </span>
    </div>
  );
};
